<template>
<t as="p" path="membership_17" class="f-bold my-8">
  Indicators and signals
</t>
<HoldOn :content="list" :height="160">
  <AsyncNullableList :list-data="list" #="{item}">
    <router-link :to="`/membership/signal/${prop('type', item)}`" class="df-middle box">
      <img :src="item.banner" class="banner" width="88" height="88" alt="" />
      <div class="ml-12">
        <t as="p" :path="item.titleI18nPath" class="f-bold">
          {{prop('title', item)}}
        </t>
        <t as="p" :path="item.profileI18nPath" class="f-sm profile mt-8">
          {{prop('profile', item)}}
        </t>
      </div>
    </router-link>
  </AsyncNullableList>
</HoldOn>
</template>

<script lang="ts">
import AsyncNullableList from '@/components/AsyncNullableList.vue'
import HoldOn from '@/provider/HoldOn.vue'
import { defineComponent } from 'vue'
import { StudyType } from 'happychart/types'

export default defineComponent({
  name: 'SignalList',
  components: { HoldOn, AsyncNullableList },
  setup () {
    return {
      list: [
        {
          titleI18nPath: 'membership_18',
          title: 'Trend Pro',
          profileI18nPath: 'membership_19',
          profile: 'See the ups and downs of the trend and overbought/oversold areas intuitively',
          banner: '/img/membership/cover_pro.jpg',
          id: 2,
          type: StudyType.TRENDPRO,
          elite: true,
        },
      ],
    }
  },
})

</script>

<style scoped lang="scss">
.banner {
  object-fit: cover;
}

.profile {
  line-height: 16px;
}
</style>
